import React from 'react';
import Reflux from 'reflux';
import { Input, Button, Col, Row } from 'bootstrap';
import SearchStore from 'flux/stores/SearchStore';
import SearchActions from 'flux/actions/SearchActions';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import role from 'shared/lib/role';
import clazzNames from 'classnames';
import DoubleConfirmButton from 'shared/components/misc/doubleConfirmButton';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import KeyBindingActions from 'flux/actions/KeyBindingActions';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';

/**
 * Cuesheet Search
 *
 */
export default React.createClass({
  mixins: [
    Reflux.connect(SearchStore, 'search'),
    Reflux.connectFilter(CuesheetStore, 'show', (st) => st.get('show')),
  ],

  contextTypes: {
    user: React.PropTypes.object,
    router: React.PropTypes.object.isRequired,
  },

  displayName: 'Search',

  /**
   * Main render
   */
  render() {
    let show = this.state.show;

    let visible = this.state.search.get('visible');

    if (!visible || !show) return null;

    return (
      <div className="search-container">
        <div className="search-container-header">
          <a
            className="search-container-header-close fa fa-times"
            onClick={() => SearchActions.toggleVisibility()}
          />
          {this._getListTitleNode()}
        </div>
        {this._getListNode()}
      </div>
    );
  },

  _hasEventContributorRole() {
    let params = this.context.router.state.params;
    let user = this.context.user;
    let { teamId, eventId } = params;

    if (!user) return;

    return role.hasEventContributorRole(user, teamId, eventId);
  },

  /**
   * Get the title node
   */
  _getListTitleNode() {
    let searchQuery = this.state.search.get('searchQuery'),
      searchFocusState = this.state.search.get('searchFocusState'),
      replaceFocusState = this.state.search.get('replaceFocusState');

    let querylength = 0;
    let queryPrefix = null;
    let prefixCutClass = '';
    // let focusClass = '';

    let _searchInputRef = this._searchInput ? this._searchInput.refs : null;
    let _searchInputRefVal =
      _searchInputRef && _searchInputRef.input
        ? _searchInputRef.input.value
        : null;

    if (searchQuery) {
      querylength = searchQuery.length;
      prefixCutClass = querylength > 18 ? 'cut-prefix' : '';

      queryPrefix = (
        <span
          className={clazzNames('search-input-replace-prefix', prefixCutClass)}
        >
          {_searchInputRefVal}&nbsp;
        </span>
      );
    }

    return (
      <div>
        <span className="search-container-header-primary-title">
          Search this show
        </span>
        <span className="search-container-header-input">
          <span
            className={clazzNames('search-wrapper', {
              'has-focus': searchFocusState === true,
            })}
          >
            <Input
              type="text"
              autoFocus
              className="search-input"
              ref={(c) => {
                if (!c) return;
                this._searchInput = c;
              }}
              addonBefore={
                <span
                  className="search-prefix-wrapper"
                  onClick={() => {
                    if (_searchInputRef) _searchInputRef.input.focus();
                  }}
                >
                  <Icon name="search" />
                  Search for:
                </span>
              }
              onFocus={this._handleSearchInputFocus}
              onBlur={this._handleSearchInputBlur}
              onChange={this._handleQueryChange}
            />
          </span>
          {this._getReplaceNodes(
            replaceFocusState,
            prefixCutClass,
            queryPrefix,
          )}
        </span>
      </div>
    );
  },

  /**
   * Replace Nodes Contains:
   *
   * Replace With Input
   * Replace All & Replace Checked Buttons
   *
   * @param replaceFocusState: adds a wrapper class with a border
   *    style to the replace input allowing the illusion
   *    addonBefore is apart of the replace input
   *
   * @param prefixCutClass: adds a class to the prefix of
   *    replace input ellipsising it when it gets to long
   *
   * @param queryPrefix: adds what is typed into the search input
   *    into the prefix of the replace input so user knows what
   *    they are replacing
   */
  _getReplaceNodes(replaceFocusState, prefixCutClass, queryPrefix) {
    let searchQuery = this.state.search.get('searchQuery');
    let itemIsChecked = this.state.search.get('itemIsChecked');
    let results = this.state.search.get('results');
    let resetReplaceAllClick = this.state.search.get('resetReplaceAllClick');
    let disableCheckedBtn = true;
    let disableAllBtn = true;
    let checkedClass = 'search-replace-checked';

    if (itemIsChecked === true && results) {
      checkedClass += ' item-checked';
    } else {
      checkedClass = 'search-replace-checked';
    }

    if (searchQuery && results) {
      disableCheckedBtn = false;
      disableAllBtn = false;
    }

    let hasLockedRows =
      results && results.findIndex((result) => result.get('locked')) !== -1;

    if (hasLockedRows) {
      disableAllBtn = true;
    }

    if (!itemIsChecked && searchQuery) disableCheckedBtn = true;

    return this._hasEventContributorRole() ? (
      <span>
        <span
          className={clazzNames('replace-wrapper', {
            'has-focus': replaceFocusState === true,
          })}
        >
          <Input
            type="text"
            className="search-input search-input-replace"
            ref={(c) => {
              if (!c) return;
              this._replaceInput = c;
            }}
            addonBefore={
              <span
                className={clazzNames(
                  'search-replace-prefix-wrapper',
                  prefixCutClass,
                )}
                onClick={() => {
                  this._replaceInput.refs.input.focus();
                }}
              >
                <Icon name="exchange" />
                Replace&nbsp;
                {queryPrefix}
                with:
              </span>
            }
            onChange={this._handleReplaceInputChange}
            onFocus={this._handleReplaceInputFocus}
            onBlur={this._handleReplaceInputBlur}
          />
        </span>
        <WithTooltip
          placement="top"
          delay={0}
          tip={
            hasLockedRows
              ? 'Search results have a cell from a locked row. Replace All is disabled.'
              : ''
          }
        >
          <span
            className={clazzNames('search-replace-all-btn', {
              disabled: disableAllBtn === true,
            })}
          >
            <DoubleConfirmButton
              disable={disableAllBtn}
              onFirstClick={() => SearchActions.setReplaceAllClickState(false)}
              onSecondClick={this._handleReplaceAll}
              classes="search-replace-all"
              confirmClass="search-replace-confirm"
              text="Replace All"
              confirmText="Really Replace All?"
              resetClickState={resetReplaceAllClick}
            />
          </span>
        </WithTooltip>

        <span
          className={clazzNames('search-replace-checked-btn', {
            disabled: disableCheckedBtn === true,
          })}
        >
          <Button
            className={checkedClass}
            onClick={this._handleReplaceChecked}
            disabled={disableCheckedBtn}
          >
            Replace Checked
          </Button>
        </span>
      </span>
    ) : null;
  },

  _refreshList() {
    let searchQuery = this.state.search.get('searchQuery');
    SearchActions.search(searchQuery, false);
  },

  _handleReplaceChecked() {
    SearchActions.replaceChecked();
    SearchActions.refreshList();
  },

  _handleReplaceAll() {
    SearchActions.replaceAll();

    let _searchInputRef = this._searchInput ? this._searchInput.refs : null;

    if (_searchInputRef && _searchInputRef.input) {
      _searchInputRef.input.value = '';
      _searchInputRef.input.focus();
    }

    this._replaceInput.refs.input.value = '';
  },

  _handleReplaceInputChange(e) {
    SearchActions.setReplaceInputVal(e.target.value);
  },

  _handleQueryChange(e) {
    let query = e.target.value;
    SearchActions.search(query, true);
    SearchActions.setReplaceAllClickState(true);
  },

  _getListNode() {
    let state = this.state.search,
      results = state.get('results'),
      title = state.get('noResultsTitle'),
      subtitle = state.get('noResultsSubtitle'),
      noReplaceClass = '';

    let classes = 'search-no-results';
    if (!this._hasEventContributorRole()) {
      classes += ' search-only';
      noReplaceClass = ' no-replace';
    }

    if (!results || !results.size) {
      return (
        <div>
          <div className={'text-center ' + classes}>
            <div className="search-no-results-title">{title}</div>
            <span className="search-no-results-sub-title">{subtitle}</span>
          </div>
        </div>
      );
    }

    let resultNodes = results.map(this._getSearchResultNode);

    return (
      <div className="search-result-controls">
        {this._getSearchResultCountNode()}
        <div className={'search-result-list' + noReplaceClass}>
          {resultNodes}
        </div>
      </div>
    );
  },

  _getSearchResultCountNode() {
    let state = this.state.search;
    let results = state.get('results');
    let noReplaceClass = ' no-replace';
    let activeResult = state.get('activeResultIndex')
      ? state.get('activeResultIndex') + 1
      : 1;

    let resultsNode =
      typeof state.get('activeResultIndex') === 'number'
        ? `${activeResult} of ${results.size} results`
        : `${results.size} results`;

    if (this._hasEventContributorRole()) {
      noReplaceClass = '';
    }

    return (
      <div className={'search-controls-wrapper' + noReplaceClass}>
        <Row>
          <Col md={4} mdOffset={4} sm={4} smOffset={4} xs={4} xsOffset={4}>
            <Button
              onClick={this._handlePrev}
              className={'search-result-prev-btn'}
            >
              Prev
            </Button>
          </Col>
          <Col className={'search-result-count'} md={6} sm={6} xs={6}>
            {resultsNode}
          </Col>
          <Col md={4} sm={4} xs={4}>
            <Button
              onClick={this._handleNext}
              className={'search-result-next-btn'}
            >
              Next
            </Button>
          </Col>
        </Row>
      </div>
    );
  },

  _getSearchResultNode(result, index) {
    let activeResultIndex = this.state.search.get('activeResultIndex');
    let classes = ['search-result-item-wrapper'];
    let isLocked = result.get('locked');
    let isChecked = result.get('replace');
    let noReplaceClass = ' no-replace';
    let replaceCheckbox = null;

    if (activeResultIndex === index) classes.push('active');

    if (this._hasEventContributorRole()) {
      if (isLocked) {
        replaceCheckbox = (
          <WithTooltip
            placement="top"
            delay={0}
            tip="Cell is in a locked row. Replace is disabled."
          >
            <span className="replace-check disabled">
              <Icon name="lock" />
            </span>
          </WithTooltip>
        );
      } else {
        replaceCheckbox = (
          <span className="replace-check">
            <Icon
              onClick={() => this._handleAddAndRemoveReplace(isChecked, index)}
              name={isChecked ? 'check-square' : 'square-o'}
            />
          </span>
        );
      }
      noReplaceClass = '';
    }

    return (
      <div>
        {replaceCheckbox}
        <div
          onClick={() => this._handleSetActiveResultIndex(index)}
          className={clazzNames(classes)}
        >
          <div className={'search-result-item' + noReplaceClass}>
            <span className="search-result-item-text">
              <a className="search-result-item-number">
                {result.get('number') + ' - '}
              </a>
              {result.get('displayText')}
            </span>
          </div>
        </div>
      </div>
    );
  },

  _handleSetActiveResultIndex(index) {
    SearchActions.setActiveResultIndex(index);
  },

  _handleAddAndRemoveReplace(isChecked, index) {
    if (isChecked) {
      return SearchActions.removeReplaceFromResult(index);
    } else {
      return SearchActions.addReplaceToResult(index);
    }
  },

  /**
   * Set next active search result
   */
  _handleNext() {
    let state = this.state.search;
    let nextIndex =
      typeof state.get('activeResultIndex') === 'number'
        ? state.get('activeResultIndex') + 1
        : 0;

    if (nextIndex >= state.get('results').size) return;

    this._handleSetActiveResultIndex(nextIndex);
  },

  /**
   * Set previous active search result
   */
  _handlePrev() {
    let state = this.state.search;
    let prevIndex =
      typeof state.get('activeResultIndex') === 'number' &&
      state.get('activeResultIndex') > 0
        ? state.get('activeResultIndex') - 1
        : 0;

    this._handleSetActiveResultIndex(prevIndex);
  },

  _handleSearchInputFocus() {
    SearchActions.setSearchFocusState(true);
    CuesheetCursorActions.clearCursor();
    this._unbindHotKeys();
  },

  _handleSearchInputBlur() {
    SearchActions.setSearchFocusState(false);
    this._bindHotKeys();
  },

  _handleReplaceInputFocus() {
    SearchActions.setReplaceFocusState(true);
    CuesheetCursorActions.clearCursor();
    this._unbindHotKeys();
  },

  _handleReplaceInputBlur() {
    SearchActions.setReplaceFocusState(false);
    this._bindHotKeys();
  },

  _unbindHotKeys() {
    //Unbind hotkeys when search input has focus
    KeyBindingActions.unbindHotKeys();
    KeyBindingActions.unbindNavigationKeys();

    this._rebindHotKeysCallback = () => {
      KeyBindingActions.bindHotKeys();
      KeyBindingActions.bindNavigationKeys();
    };
  },

  _bindHotKeys() {
    //Bind hotkeys when search input has loses focus
    if (!this._rebindHotKeysCallback) return;

    this._rebindHotKeysCallback();
    delete this._rebindHotKeysCallback;
  },
});
